// removed by extract-text-webpack-plugin
module.exports = {"this":"GroupMessageListModal__this___1pHxY","messages":"GroupMessageListModal__messages___1j7X3"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/GroupMessageListModal.css
// module id = 1958
// module chunks = 4